import React from 'react'
import PropTypes from 'prop-types'
import Taetigkeit from '#components/m/Ausbildungsnachweis/Taetigkeit'

const TaetigkeitenListe = ({
  maxQualificationsPerGroup,
  userId,
  taetigkeiten,
  isDisabled,
  handleChangeTaetigkeit,
  handleDeleteTaetigkeit,
  handleUpdateTaetigkeit,
  withQualification,
  withWorktime,
  canEditQualification,
}) =>
  taetigkeiten.map((taetigkeit, index) => {
    const qualificationCountFromOtherTaetigkeitenInGroup = taetigkeiten
      .filter(x => x.id !== taetigkeit.id)
      .reduce((sum, t) => sum + t.qualifikationen.length, 0)
    const allowedQualificationsForTaetigkeit =
      maxQualificationsPerGroup - qualificationCountFromOtherTaetigkeitenInGroup
    return (
      <Taetigkeit
        key={taetigkeit.id}
        isDisabled={isDisabled}
        index={index}
        userId={userId}
        handleDeleteTaetigkeit={handleDeleteTaetigkeit}
        handleChangeTaetigkeit={handleChangeTaetigkeit}
        handleUpdateTaetigkeit={handleUpdateTaetigkeit}
        taetigkeit={taetigkeit}
        withQualification={withQualification}
        withWorktime={withWorktime}
        canEditQualification={canEditQualification}
        allowedQualificationCount={allowedQualificationsForTaetigkeit}
      />
    )
  })

TaetigkeitenListe.propTypes = {
  maxQualificationsPerGroup: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  taetigkeiten: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  handleChangeTaetigkeit: PropTypes.func.isRequired,
  handleDeleteTaetigkeit: PropTypes.func.isRequired,
  handleUpdateTaetigkeit: PropTypes.func.isRequired,
  withQualification: PropTypes.bool.isRequired,
  withWorktime: PropTypes.bool.isRequired,
  canEditQualification: PropTypes.bool.isRequired,
}

export default TaetigkeitenListe
